var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReceiptsSent(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Receipts_Sent"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Receipts_Sent",
    "data-name": "Receipts Sent",
    clipPath: "url(#clip-Receipts_Sent)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(1.76 -1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_405",
    "data-name": "Path 405",
    d: "M37.55,8.55H10.857a3.337,3.337,0,0,0,0,6.673H37.55a3.337,3.337,0,0,0,0-6.673Z",
    transform: "translate(12.338 17.642)",
    fill: "#e8eaf0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_406",
    "data-name": "Path 406",
    d: "M37.55,13.9H10.857a3.337,3.337,0,0,0,0,6.673H37.55a3.337,3.337,0,0,0,0-6.673Z",
    transform: "translate(12.338 30.143)",
    fill: "#e8eaf0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_407",
    "data-name": "Path 407",
    d: "M37.55,19.37H10.857a3.337,3.337,0,1,0,0,6.673H37.55a3.337,3.337,0,0,0,0-6.673Z",
    transform: "translate(12.338 42.925)",
    fill: "#e8eaf0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_408",
    "data-name": "Path 408",
    d: "M89.327,4.337A12.746,12.746,0,0,0,81.086,1H15.22A13.013,13.013,0,0,0,2.24,14.08V95.461A4.7,4.7,0,0,0,9.381,99.5L21.66,92.124a1.168,1.168,0,0,1,1.235,0L36.541,100.3a4.471,4.471,0,0,0,2.4.7,4.871,4.871,0,0,0,2.436-.667l13.714-8.208a1.168,1.168,0,0,1,1.235,0L68.54,99.5a4.638,4.638,0,0,0,4.738,0,4.7,4.7,0,0,0,2.369-4.071V39.172H86.124a7.975,7.975,0,0,0,7.941-7.941V14.08a12.813,12.813,0,0,0-4.738-9.743ZM68.974,92.124l-9.209-5.706a7.941,7.941,0,0,0-8.108,0L38.977,94.026,26.331,86.385a7.941,7.941,0,0,0-8.208.033L8.913,91.991V14.08A6.306,6.306,0,0,1,15.22,7.673H70.342a11.945,11.945,0,0,0-1.368,5.439V92.124Z",
    transform: "translate(0 0)",
    fill: "#e8eaf0"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReceiptsSent);
export default __webpack_public_path__ + "static/media/receipts-sent.736047f63a6ea7cc684d7644f369a020.svg";
export { ForwardRef as ReactComponent };